import { render } from "./New-frame-option.vue?vue&type=template&id=c13a79f8&scoped=true"
import script from "./New-frame-option.vue?vue&type=script&lang=js"
export * from "./New-frame-option.vue?vue&type=script&lang=js"

import "./New-frame-option.vue?vue&type=style&index=0&id=c13a79f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13a79f8"]])

export default __exports__